import { isOneClick } from '@cast/constants';
import { useAbility } from '@cast/shared-ability-data-access';

import { useIsRedesignAnnouncementDialogOpen } from './redesignAnnouncementDialogGate';
import { useRedesignAnnouncementState } from './useRedesignAnnouncementState';

export const shouldDeferOnboardingChecklistOpen = ({
  isRedesignAnnouncementDialogOpen,
  canViewOneClickPromotion,
  isOneClickConsole,
  hasSeenRedesignAnnouncementDialog,
}: {
  isRedesignAnnouncementDialogOpen: boolean;
  canViewOneClickPromotion: boolean;
  isOneClickConsole: boolean;
  hasSeenRedesignAnnouncementDialog: boolean;
}): boolean =>
  isRedesignAnnouncementDialogOpen ||
  (canViewOneClickPromotion &&
    !isOneClickConsole &&
    !hasSeenRedesignAnnouncementDialog);

/**
 * True while the redesign announcement dialog is showing or about to show.
 * The Getting Started FAB can still render; only the checklist popover waits.
 */
export const useShouldDeferOnboardingChecklistOpen = (): boolean => {
  const canViewOneClickPromotion = useAbility().can(
    'view',
    'FeatureOneClickPromotion'
  );
  const { dialogSeen } = useRedesignAnnouncementState();
  const isRedesignAnnouncementDialogOpen =
    useIsRedesignAnnouncementDialogOpen();

  return shouldDeferOnboardingChecklistOpen({
    isRedesignAnnouncementDialogOpen,
    canViewOneClickPromotion,
    isOneClickConsole: isOneClick(),
    hasSeenRedesignAnnouncementDialog: dialogSeen,
  });
};
